import React from 'react';
import { Container, Image } from 'react-bootstrap';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';

const ImageCarousel = () => {
  return (
    <div className='image-carousel-container-div'>
      <Container className="image-carousel-container">
        <Swiper
          pagination={{
            clickable: true,
            dynamicBullets: false, // Turned off to show custom styling better
          }}
          autoplay={{
            delay: 3000, // Faster: Switches every 2 seconds
            disableOnInteraction: false,
          }}
          speed={800} // Speed of the actual slide transition animation
          loop={true}
          modules={[Autoplay, Pagination]} //dapat bawas yung height sa top sa first image ng carousel
          className="image-carousel"
          autoHeight={true} 
          slidesPerView={1}
        >
          <SwiperSlide>
            <div>
              {/* <img
                alt="First slide"
                loading="lazy"
                className="first-carousel-img"
                // 1. The fallback/default source (Desktop size)
                src="https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-1200,f-auto,q-80 1200w"
                
                // 2. The menu of options for the browser
                srcSet="
                  https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-400,f-auto,q-60 400w,
                  https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-800,f-auto,q-60 800w,
                  https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-1200,f-auto,q-70 1200w,
                  https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-1920,h-1100,q-80 1920w,
                  https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-2560,h-1250,fo-bottom,f-auto,q-80 2560w,
                  https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-3840,f-auto,q-80 3840w
                "
                
                // 3. Telling the browser how much space the image takes up
                sizes="100vw"
              /> */}
                {/* 1. MOBILE & TABLET (Portrait/Tall Crop) 
                    This triggers for screens up to 1024px. 
                    We use h-XXXX to force a vertical aspect ratio. */}
                {/* <source
                  media="(max-width: 1024px)"
                  srcSet="
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-400,h-600,cm-extract,fo-auto,f-auto 400w,
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-200,h-200,ar-9-16,cm-extract,f-bottom 800w,
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-1024,h-1300,cm-extract,fo-auto,f-auto 1024w
                  "
                  sizes="100vw"
                /> */}

                {/* 2. DESKTOP (Landscape/Wide Crop)
                    The <img> tag acts as the default for anything larger than 1024px. */}
                <img
                  alt="First slide"
                  loading="eager"
                  fetchpriority="high"
                  className="first-carousel-img"
                  src={'https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-1200,f-auto,q-80 1200w'}
                  srcSet={`
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-400,fo-top,q-60 400w,
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-800,fo-top,q-60 800w,
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-1200,fo-bottom,q-60 1200w,
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-1920,fo-bottom,q-70 1920w,
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-2560,fo-bottom,q-80 2560w,
                    https://ik.imagekit.io/wwg4nuz3a/jci-bod-banner.jpg?tr=w-3840,fo-top,q-80 3840w
                  `}
                  sizes="100vw"
                  // sizes="(max-width: 600px) 430px, 100vw"
                  // style={{
                  //   width: '100vw',
                  //   height: '100vh', // Let the ImageKit crop define the height if this is present mobile view height is stretched
                  // }}
                />
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="position-relative">
              <img
                alt="First slide"
                loading="lazy"
                className="second-carousel-img"
                // 1. The fallback/default source (Desktop size)
                src="https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-1200,f-auto,q-80 1200w"
                
                // 2. The menu of options for the browser
                srcSet="
                  https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-400,ar-4-3,q-60 400w,
                  https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-800,ar-4-3,q-60 800w,
                  https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-1200,ar-4-3,q-70 1200w,
                  https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-1920,ar-4-3,q-80 1920w,
                  https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-2560,ar-4-3,q-80 2560w,
                  https://ik.imagekit.io/wwg4nuz3a/home-second-slide.jpg?tr=w-3840,ar-4-3,q-80 3840w,
                "
                
                // 3. Telling the browser how much space the image takes up
                sizes="100vw"
                style={{
                  width: '100vw',
                }}
              />
              {/* <div className="carousel-caption d-none d-md-block">
                <h3>Second slide label</h3>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
              </div> */}
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="position-relative">
              <img
                className="third-carousel-img"
                loading="lazy"
                // 1. The fallback/default source (Desktop size)
                src="https://ik.imagekit.io/wwg4nuz3a/home-third-slide.jpg?tr=w-1200,f-auto,q-80 1200w"
                
                // 2. The menu of options for the browser
                srcSet="
                  https://ik.imagekit.io/wwg4nuz3a/home-third-slide.jpg?tr=w-400,f-auto,q-60 400w,
                  https://ik.imagekit.io/wwg4nuz3a/home-third-slide.jpg?tr=w-800,f-auto,q-60 800w,
                  https://ik.imagekit.io/wwg4nuz3a/home-third-slide.jpg?tr=w-1200,f-bottom,q-70 1200w,
                  https://ik.imagekit.io/wwg4nuz3a/home-third-slide.jpg?tr=w-1920,f-auto,q-80 1920w,
                  https://ik.imagekit.io/wwg4nuz3a/home-third-slide.jpg?tr=w-2560,f-auto,q-80 2560w,
                  https://ik.imagekit.io/wwg4nuz3a/home-third-slide.jpg?tr=w-3840,f-auto,q-80 3840w
                "                
                // 3. Telling the browser how much space the image takes up
                sizes="100vw"
                // style={{
                //   width: '100vw',
                //   height: '100vh', // Let the ImageKit crop define the height if this is present mobile view height is stretched
                // }}
              />
              {/* <div className="carousel-caption d-none d-md-block">
                <h3>Third slide label</h3>
                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
              </div> */}
            </div>
          </SwiperSlide>
        </Swiper>
      </Container>
    </div>
  );
};

export default ImageCarousel;